module.exports = __webpack_public_path__ + "static/media/15UN-Habitat13.d54c3ccb.jpg";